import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            maxWidth: remCalc(640),
            p: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            borderRadius: remCalc(12),
            bg: 'background.base.default',
        },
        headerFlex: {
            justifyContent: 'space-between',
        },
        header: {
            px: '0',
            py: '0',
            gap: 'micro.base',
        },
        headerContent: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            flexDirection: 'column',
        },
        shieldIcon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            h: remCalc(36),
        },
        shieldIconSvg: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        closeButtonWrapper: {
            boxSize: remCalc(36),
            border: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
        },
        closeButtonIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.default',
            cursor: 'pointer',
        },
        body: {
            gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            px: '0',
            py: 0,
        },
        contentStack: {
            spacing: remCalc(24),
        },
        title: {
            textStyle: 'body-medium',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        description: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        topicsStack: {
            spacing: remCalc(24),
            mt: remCalc(24),
        },
        topicRow: {
            spacing: remCalc(16),
            align: 'center',
        },
        topicIcon: {
            flexShrink: 0,
            width: remCalc(24),
            height: remCalc(24),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'foreground.neutral.default',
        },
        topicIconSvg: {
            width: remCalc(24),
            height: remCalc(24),
        },
        topicContent: {
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            flex: 1,
        },
        topicTitle: {
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
        },
        topicDescription: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        exploreLinkWrapper: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        exploreLink: {
            display: 'inline-flex',
            alignItems: 'center',
            color: 'foreground.accent.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
            textDecoration: 'none',
            pb: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            my: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        exploreLinkIcon: {
            width: remCalc(16),
            height: remCalc(16),
            aspectRatio: '1 / 1',
            color: 'foreground.neutral.default',
            flexShrink: 0,
        },
    },
}
